/**
 * Wire protocol v1 — message shapes shared by client and server.
 *
 * The code is the spec (docs/architecture/networking.md "Encoding And
 * Envelope"): this file plus validate.ts define exactly what may cross the
 * socket. JSON with permessage-deflate; a binary path is reserved and adopted
 * only if measurements break the bandwidth budget.
 *
 * Envelopes:
 * - client → server: { v, t, s, d } — version, type, per-connection sequence
 *   number, payload. The server ignores stale/duplicate sequence numbers.
 * - server → client: { t, tick?, seq?, d } — type, server tick where
 *   relevant, outbox sequence on replayable messages, payload.
 *
 * The session token travels in the hello/resume payload (first message on the
 * socket), never in the URL, so it cannot leak into proxy or access logs.
 */
export const PROTOCOL_VERSION = 1;
/**
 * Kick reasons the client acts on (`kick.d.reason` stays a free string on the wire). A kicked
 * client never auto-reconnects: it fails the connection and leaves the game screen.
 */
/** This account's game session was taken over by a login on another device; this login is revoked. */
export const KICK_REASON_SESSION_TAKEN_OVER = 'sessionTakenOver';
/** The same login (this device or another tab of this browser) entered the world again. */
export const KICK_REASON_LOGGED_IN_ELSEWHERE = 'loggedInElsewhere';
/**
 * The guest demo's just-in-time hints (AD-844; guest-demo.md §5.7), closed so a counter name built
 * from one is bounded. Copy and triggers live client-side (`frontend/src/ui/hints/`); this list is
 * only what the server will count.
 */
export const HINT_IDS = [
    'move',
    'find-guide',
    'gather',
    'fight',
    'craft',
    'turn-in',
    'heal',
    'decoy',
];
//# sourceMappingURL=messages.js.map